import React from 'react';
import { Card, CardContent } from '../../../../../../../components/ui/card';

interface ProjectInformationProps {
    jobData: any;
}

const ProjectInformation: React.FC<ProjectInformationProps> = ({ jobData }) => {
    const projectInfo = jobData?.parsed_json_data?.['PROJECT INFORMATION']?.values || {};

    const renderSection = (sectionName: string, sectionData: any) => {
        if (!sectionData || Object.keys(sectionData).length === 0) return null;

        return (
            <Card key={sectionName} className="bg-white border border-[#E2E5EA] shadow-sm">
                <CardContent className="p-5 w-full">
                    <h3 className="text-[14px] font-semibold text-blueprint-blue mb-4">{sectionName}</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-4">
                        {Object.entries(sectionData).map(([key, valueData]: [string, any]) => (
                            <div key={key} className="min-w-0">
                                <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">{valueData?.text || key}</div>
                                <div className="text-[13px] font-medium text-text-grey">
                                    {valueData?.value !== undefined && valueData?.value !== null ? String(valueData.value) : '-'}
                                    {valueData?.units && ` ${valueData.units}`}
                                </div>
                            </div>
                        ))}
                    </div>
                </CardContent>
            </Card>
        );
    };

    const sections = ['Identification', 'Base Material Information', 'Joint Information', 'Filler Metal Information', 'Process Information'];

    return (
        <div className="p-6 space-y-4">
            {sections.map(section => renderSection(section, projectInfo[section]))}
        </div>
    );
};

export default ProjectInformation;

